/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import { Container } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { Col, Row } from '../../modules/common/components/elements';
import androidStore from '../../images/android-footer.png';
import appStore from '../../images/ios-footer.png';
import footerLogo from '../../images/img_dino_eat_circle.png';

interface Props {}

const FooterLink = styled.p`
  text-transform: uppercase;
  margin: 10px;
  a {
    font-size: 14px;
    color: #ccc;
    &:hover {
      color: #ffcc00;
    }
  }
`;
const FooterWrap = styled.div`
  display: block;
  align-item: center;
  justify-content: center;
  @media (max-width: 767px) {
    display: flex;
    margin-bottom: 20px;
  }
`;
const FooterLinkWrap = styled.div`
  display: flex;
  align-item: center;
  justify-content: center;
  padding: 30px 0;
  @media (max-width: 767px) {
    display: block;
    padding: 0;
  }
`;
const FooterTopStyle = styled.div`
  background: #282828;
  position: relative;
  color: #fff;
  font-size: 16px;
  z-index: 98;
  padding-top: 30px;
  @media (max-width: 767px) {
    .row-footer {
      flex-direction: column;
    }
  }
  ul {
    padding-bottom: 12px;
    max-width: 1300px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 30px;
    li {
      box-sizing: border-box;
      a {
        font-size: 15px;
        font-weight: 600;
        color: #fff;
        line-height: 23px;
        display: block;
        margin-bottom: 0.9375rem;
      }
      p {
        color: #4d4dd0;
        font-family: 'NotoSans-SemiBold';
        font-size: 15px;
        font-weight: 600;
        line-height: 48px;
        padding: 0;
        margin-top: 12px;
      }
    }
  }
`;
const FooterTop: React.FC<Props> = (props) => {
  return (
    <FooterTopStyle>
      <Container>
        <FooterWrap>
          <Col>
            <Row
              className="row-footer"
              style={{ alignItems: 'flex-start', justifyContent: 'center' }}
            >
              <img style={{ maxWidth: 128 }} src={footerLogo} alt="Dinogo" />
            </Row>
          </Col>
          <Col>
            <FooterLinkWrap style={{ justifyContent: 'center' }}>
              <FooterLink>
                <a href="https://dinogo.com/dieu-khoan-su-dung/">Điều khoản sử dụng</a>
              </FooterLink>
              <FooterLink>
                <a href="https://dinogo.com/chinh-sach-bao-mat/">Chính sách bảo mật</a>
              </FooterLink>
              <FooterLink>
                <a href="https://dinogo.com/quy-che-hoat-dong/">Quy chế hoạt động</a>
              </FooterLink>
            </FooterLinkWrap>
          </Col>
        </FooterWrap>

        <Row style={{ justifyContent: 'center' }}>
          <Col style={{ marginBottom: 30, marginRight: 15 }}>
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.dinogo.android"
            >
              <img style={{ height: 45 }} src={androidStore} alt="Google Play" />
            </a>
          </Col>
          <Col style={{ marginBottom: 30 }}>
            <a
              target="_blank"
              href="https://itunes.apple.com/us/app/dinogo-du-l%E1%BB%8Bch-th%C3%B4ng-minh/id1459487385"
            >
              <img style={{ height: 45 }} src={appStore} alt="App Store" />
            </a>
          </Col>
        </Row>
      </Container>
    </FooterTopStyle>
  );
};

export default FooterTop;
